import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=b56de2fc&scoped=true"
import script from "./Macro.vue?vue&type=script&lang=js"
export * from "./Macro.vue?vue&type=script&lang=js"
import style0 from "./Macro.vue?vue&type=style&index=0&id=b56de2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56de2fc",
  null
  
)

export default component.exports